// extracted by mini-css-extract-plugin
export default {"rigthNavigarion":"CarouselRight_rigthNavigarion__zn9z6"};